/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'react';
import Accordion from './Accordion.js';
import { ACCORDION_VARIANT } from './constants.js';
import { jsx } from 'react/jsx-runtime';

var AccordionSecondary = function AccordionSecondary(props) {
  return /*#__PURE__*/jsx(Accordion, _objectSpread({
    variant: ACCORDION_VARIANT.SECONDARY
  }, props));
};

export { AccordionSecondary as default };
